<template>
    <div class="middle_wrap">
        <div class="m_head">
            <div class="center">
                <img src="../../../images/tisu/jiasu2_yd_icon.svg" alt="">
                <p class="operator">中国移动</p>
                <p class="long">|</p>
<!--                <p class="txt">-->
<!--                    测速网宽带提速营业厅-->
<!--                    <img src="../../../images/jiasu/black-quare.svg">-->
<!--                    <jiasu-header-operator-list :propsOperator="`移动`"/>-->
<!--                </p>-->
                <jiasu-header-operator-list :propsOperator="`移动`"/>
<!--                <div class="mycombo showMyCombo">-->
<!--                    <a class="cmcc" @click="gotoJiasu">中国电信/联通宽带提速营业厅 ></a>-->
<!--                </div>-->
            </div>
          <div class="bottom-tips">
            <p>宽带提速由运营商（中国电信、中国联通）提供技术支持，官方产品，值得信赖！</p>
          </div>
        </div>
        <cmcc></cmcc>
        <jiasu2-introduce :isCMCC="true"></jiasu2-introduce>
        <cmcc-sus-dom></cmcc-sus-dom>
    </div>
</template>

<style lang="scss" scoped>
p {
    margin: 0;
}

//@media screen and (min-width: 1200px) and (max-width: 1450px) {
//    .center {
//        width: 1160px !important;
//    }
//}

.middle_wrap {
    min-width: 1200px;
    .m_head {
        min-width: 1486px;
        width: 100%;
        //height: 88px;
        //display: flex;
        //justify-content: center;

        position: fixed;
        z-index: 40;
        top: 0;
        background: #fff;

        .center {
            width: 1333px !important;
            display: flex;
            align-items: center;
            position: relative;
          margin: 0 auto;
          height: 88px;


            .operator {
                color: #005DA6;
                font-size: 24px;
                margin-left: 12px;
            }

            .lt {
                color: #FF564D;
            }

            .long {
                color: #E6E6E7;
                font-size: 24px;
                margin: 0 20px;
            }

            .txt {
                color: #333333;
                font-size: 24px;
                position: relative;
            }

            .mycombo {
                position: absolute;
                right: 0;
                cursor: pointer;
                display: flex;

                .cmcc {
                    color: #3BA9FF;
                    font-weight: 700;
                    margin: auto;
                }
            }

            .showMyCombo {
                .m_ic {
                    color: #FF8200;
                }
            }
        }
      .bottom-tips{
        height: 40px;
        background: rgba(250,130,0,0.1);
        border-top: 4px solid #FF8200;
        p{
          line-height: 40px;
          width: 1330px;
          font-size: 14px;
          font-weight: 400;
          color: #FF8200;
          margin: 0 auto;
        }
      }
    }
}


</style>
<script>
export default {
    components: {
        'default-nodes': resolve => require(['../../defaultNodes'], resolve),
        'jiasu2-introduce': resolve => require(['./jiasu2Introduce.vue'], resolve),
        'cmcc': resolve => require(['./cmcc.vue'], resolve)
    },
    methods:{
        gotoJiasu(){
            sessionStorage.setItem('tisuOperatorPage','电信')
            location.href=location.origin + '/jiasu'
        },
    },
    mounted() {
        let tisuOperatorPage=sessionStorage.getItem('tisuOperatorPage')||''
        if(tisuOperatorPage&&tisuOperatorPage!=='移动'){
            location.href=location.origin + '/jiasu'
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/js/components/Jiasu/cmccMiddle.vue